import { restApiService } from '../services/services';
import { storableError } from '../util/errors';

// ================ Action types ================ //

const PRICE_HISTORY_CHART_REQUEST = 'app/PriceAnalysisData/PRICE_HISTORY_CHART_REQUEST';
const PRICE_HISTORY_CHART_SUCCESS = 'app/PriceAnalysisData/PRICE_HISTORY_CHART_SUCCESS';
const PRICE_HISTORY_CHART_ERROR = 'app/PriceAnalysisData/PRICE_HISTORY_CHART_ERROR';

const PRICE_HISTORY_CHART_INFLATION_REQUEST = 'app/PriceAnalysisData/PRICE_HISTORY_INFLATION_CHART_REQUEST';
const PRICE_HISTORY_CHART_INFLATION_SUCCESS = 'app/PriceAnalysisData/PRICE_HISTORY_INFLATION_CHART_SUCCESS';
const PRICE_HISTORY_CHART_INFLATION_ERROR = 'app/PriceAnalysisData/PRICE_HISTORY_INFLATION_CHART_ERROR';

// ================ Reducer ================ //

const initialState = {
  priceHistoryChartData: {},
  isPriceHistoryChartDataLoading: false,
  priceHistoryChartDataError: null,
  priceHistoryChartDataInflation: {},
  isPriceHistoryChartDataInflationLoading: false,
  priceHistoryChartDataInflationError: null,
};

const priceAnalysisDataReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case PRICE_HISTORY_CHART_REQUEST:
      return {
        ...state,
        isPriceHistoryChartDataLoading: true,
        priceHistoryChartDataError: null,
      };

    case PRICE_HISTORY_CHART_SUCCESS:
      return {
        ...state,
        priceHistoryChartData: payload,
        isPriceHistoryChartDataLoading: false,
      };

    case PRICE_HISTORY_CHART_ERROR:
      return {
        ...state,
        isPriceHistoryChartDataLoading: false,
        priceHistoryChartDataError: payload,
      };

    case PRICE_HISTORY_CHART_INFLATION_REQUEST:
      return {
        ...state,
        isPriceHistoryChartDataInflationLoading: true,
        priceHistoryChartDataInflationError: null,
      };

    case PRICE_HISTORY_CHART_INFLATION_SUCCESS:
      return {
        ...state,
        priceHistoryChartDataInflation: payload,
        isPriceHistoryChartDataInflationLoading: false,
      };

    case PRICE_HISTORY_CHART_INFLATION_ERROR:
      return {
        ...state,
        isPriceHistoryChartDataInflationLoading: false,
        priceHistoryChartDataInflationError: payload,
      };

    default:
      return state;
  }
}

export default priceAnalysisDataReducer;

// ================ Selectors ====================== //

export const $priceHistoryChartData = state => {
  const priceHistoryChartData = state.PriceAnalysisData.priceHistoryChartData;
  const priceHistoryChartDataInflation = state.PriceAnalysisData.priceHistoryChartDataInflation;

  return {
    real: priceHistoryChartData,
    inflation: priceHistoryChartDataInflation,
  };
};

// ================ Action creators ================ //

const getPriceHistoryChartDataSuccess = payload => ({
  type: PRICE_HISTORY_CHART_SUCCESS,
  payload: payload,
});

const getPriceHistoryChartDataError = errorMsg => ({
  type: PRICE_HISTORY_CHART_ERROR,
  payload: errorMsg,
});

const getPriceHistoryChartDataRequest = () => ({
  type: PRICE_HISTORY_CHART_REQUEST,
});


const getPriceHistoryChartDataInflationSuccess = payload => ({
  type: PRICE_HISTORY_CHART_INFLATION_SUCCESS,
  payload: payload,
});

const getPriceHistoryChartDataInflationError = errorMsg => ({
  type: PRICE_HISTORY_CHART_INFLATION_ERROR,
  payload: errorMsg,
});

const getPriceHistoryChartDataInflationRequest = () => ({
  type: PRICE_HISTORY_CHART_INFLATION_REQUEST,
});

// ================ Thunks ================ //

const priceHistoryChartDataRequest = (params) => {
  return restApiService.publicInstance
    .getRaw('/pricing-analysis/price-history-chart-data', {params: {...params}});
}

export const fetchPriceHistoryChartData = ({maker, model, year}) => (dispatch, getState, sdk) => {
  if(!maker || !model) {
    return Promise.resolve();
  }

  dispatch(getPriceHistoryChartDataRequest());

  return priceHistoryChartDataRequest({ maker, model, year })
    .then(chartData => {
      dispatch(getPriceHistoryChartDataSuccess(chartData.data));
      return chartData.data;
    })
    .then(() => {
      dispatch(getPriceHistoryChartDataInflationRequest());

      return priceHistoryChartDataRequest({ maker, model, year, inflation: true })
        .then(chartData => {
          dispatch(getPriceHistoryChartDataInflationSuccess(chartData.data));
          return chartData.data;
        })
        .catch(e => {
          dispatch(getPriceHistoryChartDataInflationError(storableError(e)));
          throw e;
        })
        ;
    })
    .catch(e => {
      dispatch(getPriceHistoryChartDataError(storableError(e)));
      throw e;
    })
    ;
}
